import React from 'react';
import { toastr } from 'react-redux-toastr';
import { Column } from '../lib_react_adminlte/componentes/Table.jsx';
import LabeledInput from '../lib_react_adminlte/componentes/LabeledInput.jsx';
import Cadastro from './Cadastro.jsx';
import Api from '../utils/Api.jsx';
import RecordSelect from '../lib_react_adminlte/componentes/RecordSelect.jsx';

/**
 * Componente de cadastro de funcionário.
 */
export default class CadastroUsuario extends React.Component {

  state = {
    registros: [],
    registro: this.getRegistroLimpo(),
    empresasNaoAdicionadas: [],
    empresasAdicionadas: [],
  };

  async componentWillMount() {
    this.getEmpresasNaoAdicionadas('');
  }

  onChange(prop, event) {
    this.setState({
      registro: {
        ...this.state.registro,
        [prop]: event.target ? event.target.value : event,
      },
    });
  }
  async getEmpresasNaoAdicionadas(empresas) {
    const ret = await Api.getEmpresasNaoAdicionadas(empresas);
    if (!ret.status) {
      return toastr.error('Atenção!', 'Erro ao buscar as empresas', 2);
    }
    
    this.setState({ empresasNaoAdicionadas: ret.dados, constanteNao: ret.dados });
  }

  /**
   * Retorna a mensagem de confirmação ao excluir.
   */
  getMsgExcluir() {
    return 'Tem certeza que deseja excluir ' + this.state.registro.nome_usuario + ' ?';
  }

  /**
   * Retorna um registro limpo.
   */
  getRegistroLimpo() {
    return {
      nome_usuario:'',
      email:'',
      senha:'',
    };
  }

  /**
   * Retorna as ações da tabela.
   */
  async getRegistros(filtro) {
    const ret = await Api.getUsuarios(filtro);
    if (!ret.status) {
      return toastr.error('Erro!', ret.erro.error_message);
    }
    
    this.setState({ itemSelecionado: null });
    this.setState({ registros: ret.dados.usuario });
    this.getEmpresasNaoAdicionadas('');
    return ret;
  }
 

  /**
   * Retorna o registro.
   */
  getRegistro() {
    const copy = Object.assign({}, this.state.registro);
    copy.empresasAdicionadas = this.state.empresasAdicionadas;
    return copy;
  }
  /**
   * seta o registro com o item recebido da lista da tabela
   * @param {} item 
   */
  setRegistro(item) {
    this.setState({ registro: item, empresasAdicionadas: item.empresas });
    this.getEmpresasNaoAdicionadas(item.empresas);
  }
  /**
   * Limpa o registro atual.
   */
  async limparRegistro() {
    this.setState({
      registro: this.getRegistroLimpo(),
      itemSelecionado: null,
      empresasAdicionadas: [],
    });
  }

  /**
   * Renderiza as colunas que aparecerão no grid da listagem.
   */
  renderColunas() {
    return [
      <Column key={1} field="nome_usuario" header="Nome do Usuario" />,
      <Column key={2} field="email" header="E-mail" />,
    ];
  }

  renderColunasRecordSelect() {
    return [
      <Column key={1} field="razao_social" header="Razão social" />,
      <Column key={2} field="doc_federal" header="CNPJ" />,
    ];
  }

  /**
   * Renderiza o formulário de inclusão/alteração.
   */
  renderForm() {

    return (
      <div>
        <div>
          <div className="row mt-5">
            <div className="col-sm-5">
              <LabeledInput label="Nome do Usuario:"
                            value={this.state.registro.nome_usuario}
                            onChange={this.onChange.bind(this, 'nome_usuario')} />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-sm-5">
              <LabeledInput label="E-mail:"
                            uppercase='false'
                            value={this.state.registro.email}
                            onChange={this.onChange.bind(this, 'email')} />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-sm-5">
              <LabeledInput label="Senha:"
                            uppercase='false'
                            placeholder='Segredo'
                            onChange={this.onChange.bind(this, 'senha')} />
            </div>
          </div>
        </div>

        <RecordSelect listaNaoAdicionado={this.state.empresasNaoAdicionadas}
                      listaAdicionado={this.state.empresasAdicionadas}
                      tituloNaoAdicionado="Não adicionados"
                      tituloAdicionado="Adicionados"
                      colunas={this.renderColunasRecordSelect()} 
                      constanteNao={this.state.constanteNao}
                      onChangeNaoAdicionado={(l) => this.setState({ empresasNaoAdicionadas: l })}
                      onChangeAdicionado={(l) => {
                          this.setState({ empresasAdicionadas : l });
                          }} />
      </div>
      

    );
  }
  
  render() {
    
    return (
      <div>
        <Cadastro tabela="usuario"
                  pk="id"
                  titulo="Cadastro de Usuarios"

                  tableSelecionavel
                  itemSelecionadoTable={this.state.itemSelecionado}
                  onSelecionarItemTable={e => this.setState({ itemSelecionado: e })}

                  renderForm={this.renderForm.bind(this)}
                  renderColunas={this.renderColunas.bind(this)}


                  getMsgExcluir={this.getMsgExcluir.bind(this)}
                  getRegistros={this.getRegistros.bind(this)}
                  getRegistro={this.getRegistro.bind(this)}
                  setRegistro={this.setRegistro.bind(this)}

                  limparRegistro={this.limparRegistro.bind(this)}
                  ref={e => this.cadastro = e} />


      </div>
    );
  }

}




// WEBPACK FOOTER //
// ./src/componentes/CadastroUsuario.jsx